import React from "react";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import locale from "@bonliva-crm/locale";
import { ConsultantImportResultOK } from "../utils";
import { Body, RegularButton } from "@components";
import { ThemeType } from "@theme";

export type FinalResultProps = {
  result: ConsultantImportResultOK;
  onStartAgain: () => void;
};

export function FinalResult(props: FinalResultProps) {
  const classes = useStyles({});
  const { result, onStartAgain } = props;

  return (
    <div className={classes.wrapper}>
      <Paper className={classes.root}>
        <Body block>{locale.ImportSuccess}</Body>
        <Body block>{result.Msg}</Body>

        <RegularButton onClick={onStartAgain} style={{ marginTop: 16 }}>
          {locale.StartAgain}
        </RegularButton>
      </Paper>
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
  },

  root: {
    ...theme.mixins.childrenMarginBottom(16),
    align: "flex-start",
    marginBottom: "10%",
    padding: 16,
    textAlign: "center",
    width: "40rem"
  }
}));
